var _path, _rect, _path2, _path3, _path4, _path5, _path6, _g, _circle, _circle2, _circle3, _ellipse, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmptyStateSearch = function SvgEmptyStateSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 145,
    viewBox: "0 0 176 145",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0488 8.76025C-5.9352 24.4333 -1.4213 61.507 4.24212 78.0843C12.2376 97.6754 28.4006 119.048 47.7172 127.314C70.0213 136.859 103.502 134.22 121.675 131.333C137.483 128.821 167.749 118.774 173.145 109.23C178.541 99.6852 177.959 81.0985 156.472 72.5587C138.776 65.5259 125.989 39.4031 111.681 22.8266C97.3718 6.25018 57.0287 -10.8311 22.0488 8.76025Z",
    fill: "#EBEFF3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 19.5,
    width: 148,
    height: 101,
    rx: 2.5,
    fill: "white",
    stroke: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161 26L14 26",
    stroke: "#E4E4E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.687 66.5997C116.598 54.0459 102.286 48.0349 89.828 53.1948C79.3319 57.5035 73.3948 68.3551 74.826 79.1535L52.6146 88.2497C49.487 89.5264 48.0027 93.0904 49.275 96.2288C50.5472 99.3673 54.0989 100.857 57.2265 99.5801L79.438 90.4839C85.9053 99.3141 97.7796 102.985 108.382 98.6226C120.839 93.4627 126.829 79.1535 121.687 66.5997Z",
    fill: "#9DCEFE",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.707 63.7609C109.58 51.2866 95.3612 45.3137 82.8869 50.4409C70.4126 55.5152 64.4397 69.7866 69.5668 82.208C74.6411 94.6824 88.9126 100.655 101.334 95.5281C113.808 90.4538 119.781 76.1823 114.707 63.7609ZM110.795 80.7809C108.734 85.7495 104.823 89.6081 99.8012 91.6695C97.3169 92.6738 94.7797 93.2024 92.1369 93.2024C83.8912 93.2024 76.544 88.2866 73.4254 80.6223C69.1968 70.3152 74.1654 58.4752 84.4726 54.2994C86.904 53.2951 89.494 52.7666 92.1369 52.7666C100.383 52.7666 107.73 57.6823 110.848 65.3466C112.857 70.3152 112.857 75.8123 110.795 80.7809Z",
    fill: "#9DCEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7967 92.6115C48.5853 92.7172 48.321 92.77 48.0567 92.77C47.2638 92.77 46.5767 92.2943 46.3124 91.6072C46.0481 90.9729 46.2067 90.4443 46.3124 90.1272C46.4181 89.8629 46.7353 89.3872 47.3695 89.1229L68.8824 80.2957C68.4596 78.9214 68.1424 77.5471 67.9839 76.1729L45.7838 85.2643C42.6652 86.5329 41.1852 90.0743 42.4538 93.1929C43.7224 96.3115 47.2638 97.7915 50.3824 96.5229L72.5296 87.4843C71.6839 86.3743 70.9439 85.1586 70.3096 83.89L48.7967 92.6115Z",
    fill: "#9DCEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8755 54.9549C94.1497 55.3819 90.584 56.7163 86.3051 59.7052C81.9714 62.7475 79.2834 66.1634 78.7348 66.5903C78.296 66.8572 80.1063 63.1211 85.0434 58.9579C89.4869 55.2218 93.5463 54.528 93.8755 54.9549Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.75 69.3625C125.582 69.3625 131.931 63.0133 131.931 55.1812C131.931 47.3492 125.582 41 117.75 41C109.918 41 103.568 47.3492 103.568 55.1812C103.568 63.0133 109.918 69.3625 117.75 69.3625Z",
    fill: "#FFA24D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.873 57.0722L116.369 49.7282L116.249 46.5362H119.801L119.681 49.7282L119.177 57.0722H116.873ZM118.025 62.9042C117.417 62.9042 116.905 62.6962 116.489 62.2802C116.089 61.8482 115.889 61.3202 115.889 60.6962C115.889 60.0562 116.089 59.5282 116.489 59.1122C116.905 58.6802 117.417 58.4642 118.025 58.4642C118.633 58.4642 119.137 58.6802 119.537 59.1122C119.953 59.5282 120.161 60.0562 120.161 60.6962C120.161 61.3202 119.953 61.8482 119.537 62.2802C119.137 62.6962 118.633 62.9042 118.025 62.9042Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 23,
    r: 1,
    fill: "#CE2030"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 23,
    r: 1,
    fill: "#64C67C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 23,
    r: 1,
    fill: "#FFD57C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88,
    cy: 142.5,
    rx: 53,
    ry: 2.5,
    fill: "#EBEFF3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.4317,
    height: 28.4317,
    fill: "white",
    transform: "translate(103.568 41)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyStateSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-state-search.1d0071a6.svg";
export { ForwardRef as ReactComponent };